// extracted by mini-css-extract-plugin
export default {"button":"Dropdown_button__b3u+W","menu":"Dropdown_menu__ooPwg","item":"Dropdown_item__yH7VO"};